import api from '../../api'
import { isPc } from './utils'

const alipayUrl = 'https://v.flomoapp.com/alipay'
const alipaySubscriptionUrl = 'https://v.flomoapp.com/alipay_subscription'

function alipay(baimiao) {
  api.call(
    'PUT',
    '/pro/alipay',
    {
      source: 'web',
      baimiao,
    },
    async (response) => {
      const {
        data: { data },
      } = response
      const div = document.createElement('div')
      div.innerHTML = data
      document.body.appendChild(div)
      document.forms[0].submit()
    },
  )
}

function alipay_subscription_for_web(plan) {
  api.call(
    'PUT',
    '/pro/alipay_subscription_for_web',
    {
      type: plan,
      source: isPc() ? 'web' : 'mobile',
    },
    async (response) => {
      const {
        data: { data },
      } = response
      const div = document.createElement('div')
      div.innerHTML = data
      document.body.appendChild(div)
      document.forms[0].submit()
    },
  )
}

export { alipay, alipayUrl, alipay_subscription_for_web, alipaySubscriptionUrl }
